<!-- 配件待入数据 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">单据提交时间</div>
                <div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" style="height: 32px">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch" style="height: 32px">重置</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column min-width="160px" prop="OrderCode" label="单号" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160px" prop="CusName" :label="OType == 1 ?'供应商/调入仓':'客户'" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="Count" label="数量">
                    <template slot-scope="scope">
                        <el-tag size="small" type="success" v-if="scope.row.OrderType == 1"> 采购 </el-tag>
                        <el-tag size="small" type="danger" v-if="scope.row.OrderType == 2"> 销售退货 </el-tag>
                        <el-tag size="small" type="warning" v-if="scope.row.OrderType == 4"> 调拨 </el-tag>
                        {{ scope.row.Count }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="IOCounted" label="已入库数量"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="UnIOCount" label="待入库数量"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="160px" prop="CreateTime" label="单据提交时间"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        EntpTempGoodsId: {
            type: String
        },
        //所有待入，1待入库，2退货待入
        OType: { type: String, default: '0' }
    },
    data() {
        return {
            loading: false,
            dateTimes: '',
            searchData: {
                GoodsId: this.EntpTempGoodsId,
                OType: this.OType,
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            },
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData = {
                GoodsId: this.EntpTempGoodsId,
                OType: this.OType,
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            };
            this.dateTimes = [];
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        updateTableData(id, otype) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            if (otype) this.searchData.OType = otype;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsNeedInDatas',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
.search-ctn {
    margin-top: 5px;
}
.table-ctn .el-table {
    margin-bottom: 0px;
}
</style>
